// extracted by mini-css-extract-plugin
export var anticlockwise = "cw_lS";
export var svg = "cw_lQ";
export var wrapper = "cw_B";
export var wrapperFlexCenter = "cw_lR";